// import { Post } from '@/services/Api'
import { ListMenuURL, MineMenuURL, CreateMenuURL, UpdateMenuURL, DeleteMenuURL } from '@/consts/consts'
import {POST} from "@/utils/request/request";

export function CreateMenu(data) {
  return POST(CreateMenuURL, data)
}

export function DeleteMenu(data) {
  return POST(DeleteMenuURL, data)
}

export function UpdateMenu(data) {
  return POST(UpdateMenuURL, data)
}

export function ListMenu(data) {
  return POST(ListMenuURL, data)
}

export function MineMenu(data) {
  return POST(MineMenuURL, data)
}
